import React from 'react';
import AirPicker from './AirPicker';
import filterObserver from '../observer/FilterService';

export default class DatePicker extends React.Component {

  render() {
    console.log('date is ')
    return (
      <div>
        <AirPicker 
          onSelect={ function onSelect(fd, date, inst) {
            // console.log('date is ', date)
            // console.log('fd is ', fd)
            // console.log('inst is ', inst)
            filterObserver.notify({ online_date: fd });
          }}
          todayButton={new Date()}
          minDate={new Date()}
          dateFormat='dd/mm/yyyy'
        />
      </div>
    );
  }
}

